import { gql, useQuery } from '@apollo/client';
import {
  FormControl,
  FormControlProps,
  FormLabel,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';

import {
  MembershipTypeFilter_MembershipTypes,
  MembershipTypeFilter_MembershipTypesVariables,
} from './graphql-types/MembershipTypeFilter_MembershipTypes';

const MEMBERSHIP_TYPES = gql`
  query MembershipTypeFilter_MembershipTypes($input: MembershipTypesInput!) {
    membershipTypes(input: $input) {
      ... on MembershipTypesSuccess {
        results {
          _id
          name
        }
      }
    }
  }
`;

export const MembershipTypeFilter: React.FC<
  {
    isActive?: boolean;
    isPublic?: boolean;
    includeIndividualMemberships?: boolean;
    includeCorporateMemberships?: boolean;
    value: string[];
    onChange: (value: string[]) => void;
  } & Omit<FormControlProps, 'value' | 'onChange'>
> = ({
  value,
  onChange,
  isActive = undefined,
  isPublic = undefined,
  includeIndividualMemberships = undefined,
  includeCorporateMemberships = undefined,
  ...props
}) => {
  const query = useQuery<
    MembershipTypeFilter_MembershipTypes,
    MembershipTypeFilter_MembershipTypesVariables
  >(MEMBERSHIP_TYPES, {
    variables: {
      input: {
        limit: 100,
        offset: 0,
        filter: {
          isActive,
          isPublic,
          includeIndividualMemberships,
          includeCorporateMemberships,
        },
      },
    },
  });

  return (
    <FormControl {...props}>
      <FormLabel textStyle="detailStrong">Membership Type</FormLabel>
      <Menu closeOnSelect={false}>
        <MenuButton as={SelectButton} variant="menu">
          {value.length === 0
            ? 'All'
            : value.length === 1
            ? query.data?.membershipTypes.results.find(
                (membershipType) => membershipType.name === value[0]
              )?.name
            : `(${value.length}) Selected`}
        </MenuButton>
        <MenuList>
          <MenuOptionGroup value={value} onChange={onChange} type="checkbox">
            {query.data?.membershipTypes.results.map((membershipType) => (
              <MenuItemOption
                key={membershipType._id}
                value={membershipType.name}
              >
                {membershipType.name}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </FormControl>
  );
};
